// removed by extract-text-webpack-plugin
module.exports = {"container":"root-module__container___q7OCb"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/root/root.module.scss
// module id = 1294
// module chunks = 0